/**
 * FlexiPage Theme
 * Cryonix.cz
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license Commercial
 */
"use strict";
function bindMoreBlocks() {
    var bindBlock = function (blockEl) {
        var contentEl = blockEl.querySelector(".more-content");
        var linkEl = blockEl.querySelector('a[href="#vice"]');
        linkEl.addEventListener("click", function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            contentEl.classList.toggle('opened');
            linkEl.classList.toggle('active');
            return false;
        });
    };
    var blocks = document.body.querySelectorAll(".more-block");
    for (var i = 0; i < blocks.length; i++)
        bindBlock(blocks.item(i));
}
exports.bindMoreBlocks = bindMoreBlocks;



/*****************
 ** WEBPACK FOOTER
 ** ./ts/styles.ts
 ** module id = 4
 ** module chunks = 0
 **/